import React from 'react';

const LoadingOverlay = ({ message = "Procesando solicitud..." }) => {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Procesando...</span>
                </div>
                <div className="mt-3">{message}</div>
            </div>
        </div>
    );
};

export default LoadingOverlay;
